import ajax from "../../lib/appfuse-react/core/ajax";

const courseBriefService = {
    find: async ({predicate = '', sort = '', page, size}) => {
        const response = await ajax.get('courseBriefs', { predicate, sort, page, size });
        const data = response.data;
        data.totalElements = response.totalElements;
        return data;
    }
}

export default courseBriefService;